// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import { BASE_URL } from "../../../Config";

// const ViewSinglePage = () => {
//   const { id } = useParams();
//   const [asana, setAsana] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const fetchAsana = async () => {
//     try {
//       const token = sessionStorage.getItem("token");

//       const res = await axios.get(`${BASE_URL}/allpages/${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         withCredentials: true,
//       });

//       setAsana(res.data.data);
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAsana();
//   }, []);

//   if (loading) return <p>Loading...</p>;

//   if (!asana) return <p>No data found.</p>;

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>Alternative </h2>

//       <div
//         style={{
//           padding: "15px",
//           background: "#f9f9f9",
//           borderRadius: 8,
//           lineHeight: 1.6,
//         }}
//         dangerouslySetInnerHTML={{ __html: asana.content }}
//       />
//     </div>
//   );
// };

// export default ViewSinglePage;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../../Config";

const ViewSinglePage = () => {
  const { id } = useParams();
  const [asana, setAsana] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("category"); // for dictionary

  const fetchAsana = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/allpages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setAsana(res.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAsana();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!asana) return <p>No data found.</p>;

  // Check if this is a dictionary page
  const isDictionary = asana.categoryContent || asana.alphabetContent;

  // Determine which content to show
  const getContent = () => {
    if (isDictionary) {
      return activeTab === "category"
        ? asana.categoryContent
        : asana.alphabetContent;
    }
    return asana.content;
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>{asana.yogaType || asana.page || "Page Preview"}</h2>

      {/* Show tabs only for dictionary pages */}
      {isDictionary && (
        <div style={{ marginBottom: 16, display: "flex", gap: 8 }}>
          <button
            onClick={() => setActiveTab("category")}
            style={{
              padding: "6px 20px",
              borderRadius: 6,
              border: "none",
              cursor: "pointer",
              background: activeTab === "category" ? "#1677ff" : "#f0f0f0",
              color: activeTab === "category" ? "#fff" : "#000",
              fontWeight: activeTab === "category" ? "bold" : "normal",
            }}
          >
            Category
          </button>
          <button
            onClick={() => setActiveTab("alphabet")}
            style={{
              padding: "6px 20px",
              borderRadius: 6,
              border: "none",
              cursor: "pointer",
              background: activeTab === "alphabet" ? "#1677ff" : "#f0f0f0",
              color: activeTab === "alphabet" ? "#fff" : "#000",
              fontWeight: activeTab === "alphabet" ? "bold" : "normal",
            }}
          >
            Alphabet
          </button>
        </div>
      )}

      <div
        style={{
          padding: "15px",
          background: "#f9f9f9",
          borderRadius: 8,
          lineHeight: 1.6,
        }}
        dangerouslySetInnerHTML={{ __html: getContent() }}
      />
    </div>
  );
};

export default ViewSinglePage;